/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Automatic save failed. {message}" |
*
* @param {Automatic_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_failed = /** @type {((inputs: Automatic_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`La sauvegarde automatique a échoué. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Automatisches Speichern fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Salvataggio automatico fallito. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Автоматическое сохранение не удалось. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en el guardado automático. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`自动保存失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`自動保存に失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्वचालित सेव विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O salvamento automático falhou. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Automatic save failed. ${i?.message}`)
});